module.exports = __webpack_public_path__ + "img/202412_bnr900_900_1.808a8e2.png";